import { Alert, AlertProps, AlertTitle, Typography } from '@mui/material';
import pluralize from 'pluralize';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { AppPages } from '../../common/routing/app-navigator';
import ListSeparator from '../../elements/ListSeparator/ListSeparator';
import { NoConnectivityBannerInfo } from '../connector-connectivity-types';

const RevokedConnectivityBanner: FC<NoConnectivityBannerProps> = ({
  info,
  ...restOfProps
}) => {
  const { connectors = [] } = info;
  const isAWSRevoked = connectors.some(c => c.name === 'AWS'); //connectors.length === 1 && connectors[0].name === 'AWS';

  return (
    <Alert
      severity='error'
      {...restOfProps}
      onClose={isAWSRevoked ? restOfProps.onClose : undefined}>
      <AlertTitle>
        <ListSeparator
          items={connectors}
          renderItem={c => <span key={c.id}>{c.name}</span>}
          resolveKey={c => c.id}
        />
        &nbsp;access has expired or been revoked.&nbsp;
        {isAWSRevoked
          ? 'Cloud Security and Artifact Integrity scanning will be disabled'
          : 'New scans are now disabled'}
        .
      </AlertTitle>
      <Typography variant='body1' color='text.primary'>
        Please enter a valid{' '}
        <ListSeparator
          items={connectors}
          renderItem={c => (
            <NavLink to={`${AppPages.Connectors}?connectorId=${c.id}`}>
              {c.name}
            </NavLink>
          )}
          resolveKey={c => c.id}
        />
        &nbsp;
        {pluralize('token', connectors.length)} in the{' '}
        <NavLink to={AppPages.Connectors}>Connectors</NavLink> page.
      </Typography>
    </Alert>
  );
};

interface NoConnectivityBannerProps extends AlertProps {
  info: NoConnectivityBannerInfo;
}
export default RevokedConnectivityBanner;
